// Single source of truth for the canonical site URL used in auth email redirects.
//
// Why: Supabase bakes the `redirect_to` value into the magic link at request
// time. If we use `window.location.origin` when running on localhost, the link
// in the email will redirect to localhost — useless once delivered to a real
// user's inbox.
//
// Resolution order:
//   1. `NEXT_PUBLIC_SITE_URL` env var (set in Vercel + .env.local for overrides)
//   2. window.location.origin, BUT only if it's not localhost
//   3. Hard-coded production URL as last-resort fallback
//
// Set NEXT_PUBLIC_SITE_URL=https://www.apnilist.co.in in Vercel project env vars.

const PROD_URL = "https://www.apnilist.co.in";

export function siteUrl(path: string = ""): string {
  const envUrl = process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, "");
  if (envUrl) return `${envUrl}${path}`;

  if (typeof window !== "undefined") {
    const origin = window.location.origin;
    const isLocal = /localhost|127\.0\.0\.1/i.test(origin);
    if (!isLocal) return `${origin}${path}`;
  }

  return `${PROD_URL}${path}`;
}
